//Common service to define site actions

import { Injectable } from '@angular/core';
import { ControlService } from '../control/control.service';

@Injectable({
  providedIn: 'root'
})
export class ActionsService {

  constructor(
    private control: ControlService
  ) { }

  public action(action: string) {

    switch (action) {
      case 'article':
        break;
      case 'externalpageload':
        break;
      case 'dialogue':
        break;
      case 'home':
        break;
      default:
        break;
    }

    //ToArticle
    //ToCategory
    //ToExternalLink
    //ToGame
    //ToModal
    //ToPopover
  }


}
